import { container } from '@goeuro/app/client/frontend-components/src/style-values/shadows';

export const colorBrandPrimary = '#132968';
export const colorBrandPrimary400 = '#425486';
export const colorBrandPrimary300 = '#717FA4';
export const colorBrandPrimary200 = '#A1A9C3';

export const colorBrandSecondary = '#fa6b6b';
export const colorBrandSecondary400 = '#FB8989';
export const colorBrandSecondary300 = '#FDB5B5';
export const colorBrandSecondary200 = '#FEDADA';
export const colorBrandSecondaryHover = '#FB8989';

export const colorMediumBlue100 = '#f5f9fd';
export const colorMediumBlue200 = '#bfd3eb';
export const colorMediumBlue300 = '#9ebce0';
export const colorMediumBlue400 = '#7ea6d6';
export const colorMediumBlue500 = '#5e90cc';

export const colorBlue = '#2a84b7';

export const colorLightBlue500 = '#acceef';
export const colorLightBlue400 = '#bdd8f2';
export const colorLightBlue300 = '#cde2f5';
export const colorLightBlue200 = '#deebf9';

export const colorSuccess600 = '#1C9D79';
export const colorSuccess = '#24C89A';
export const colorSuccess400 = '#42DDB1';
export const colorSuccess300 = '#7CE7C9';
export const colorSuccess200 = '#C4F4E7';
export const colorSuccess100 = '#E6FEF7';

export const colorDanger500 = '#DF1B0A';
export const colorDanger = '#F53727';
export const colorDanger300 = '#F87368';
export const colorDanger200 = '#FFF2F1';

export const colorWarning600 = '#D07E09';
export const colorWarning = '#F7AF48';
export const colorWarning400 = '#F9BF6D';
export const colorWarning300 = '#FACF91';
export const colorWarning200 = '#FCDFB6';
export const colorWarning100 = '#FFF7ED';

export const colorInfo600 = '#3366A2';
export const colorInfo = '#5E90CC';
export const colorInfo400 = '#7EA6D6';
export const colorInfo300 = '#9EBCE0';
export const colorInfo200 = '#BFD3EB';
export const colorInfo100 = '#F5F9FD';

export const colorGrey80 = '#333';
export const colorGrey200 = '#FCFCFD';
export const colorGrey300 = '#F6F7F9';
export const colorGrey400 = '#F1F2F6';
export const colorGrey500 = '#DCDFE9';

export const colorWhite = '#ffffff';
export const colorBlack = '#000000';

export const searchBarBoxShadow =
  'inset 0 -1px 0 0 rgba(0, 0, 0, 0.1), 0 8px 16px 0 rgba(19, 41, 104, 0.2)';
export const imageBoxShadow = container.default;
export const borderRadius = '8px';
export const imageBackgroundFallback = '#d5d8e3';
